import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/TerminalHandling/TPTRequestHistory.css';
import createappointmentimg from '../../../Assets/TruckVisits/Assets-Desktop/create-appointment.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';

import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { TERMINAL_HANDLING_ENDPOINT } from '../../../Services/config/apiEndPoints';

class TPTRequestHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: false,
            TPTRequestHistoryData: [],
        }
    }
    getTPTRequestHistory = () => {
        ApiCall(
            'GET',
            serviceBaseURL + TERMINAL_HANDLING_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((apiData) => {

            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log("in 500");
                    this.setState({ errorMessage: true });
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData);
                    this.setState({ TPTRequestHistoryData: apiData });
                }
            }
        });

    }
    componentDidMount = () => {
        this.getTPTRequestHistory();
    }
    handleDetails = (index) => {
        this.state.TPTRequestHistoryData?.find((name) => {
            if (name.requestId === this.state.TPTRequestHistoryData[index].requestId) {
                this.props.history.push({
                    pathname: `/TPTRequestDetails/${name.requestId}`,
                    state: name
                });
            }
        })
    }
    createRequest = () => {
        this.props.history.push('/TPTRequestService')
    }

    render() {

        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.TPTRequestHistoryTitle} description={TitleDescription.TPTRequestHistoryDiscription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullTruckAppointment">
                    <div id="csnobox111">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Terminal Handling History</small>
                            </div>
                            <div id="THRailHistoryNAcceptMobile"
                                className="THRailHistoryNNavbarNameRight"
                                onClick={() => this.createRequest()}
                            >
                                <img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                <small id="adsh1saveEnable" >Request Service</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <nav class="THRailHistoryNMobileNavbar">
                            <div className="THRailHistoryNNavbarNameRight" onClick={() => this.createRequest()}>
                                <img src={createappointmentimg} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                <small id="adsh1saveEnable" >Request Service</small>
                            </div>
                        </nav>
                        <hr class="hrCDMobile" />
                        <div class="THRailHistoryPartitionDiv">
                            <div class='RailHeadingDiv'>
                                <small class='RailHeadingSmaill'>For further assistance please contact</small>
                                <small class='RailHeadingSmaillRed'>tptcallcentre@transnet.net</small>
                            </div>
                            <div id="DataTopDivRailHistory">
                                {!this.state.errorMessage ?
                                    (this.state.TPTRequestHistoryData?.map((name, index) => {
                                        return (
                                            <div class="RailHistoryMainCardDiv" onClick={() => this.handleDetails(index)}>
                                                <div class="RailHistoryDivRow" >

                                                    <div class="RailHistoryMainColumn1">
                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Request ID</small>
                                                            <small id='RailHistoryValue'>{name?.requestId}</small>
                                                        </div>
                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Request Date & Time</small>
                                                            <small id='RailHistoryValue'>{FormatTimeStamp(name?.responseData?.dateTime).timedateToLocale}</small>
                                                        </div>

                                                        <div class='RailHistoryMainColumn'>
                                                            <small id="RailHistoryLable">Status</small>
                                                            <small id={name.responseData?.status == 'Mail Sent' ? 'RailHistoryValue' : (name?.responseData?.status == 'Closed' ? 'RailHistoryValueOrange' : 'RailHistoryValueCancled')}>
                                                                {name?.responseData?.status}</small>
                                                        </div>
                                                    </div>
                                                    <div class="RailHistoryArrow" >
                                                        <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))
                                    :
                                    <div class="notruckfound1">
                                        <small id="nodatamessage1">No result found</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

export default TPTRequestHistory;